import { Property, Lien } from "@ploy-lib/types";
import {
	FieldType,
	IFormTableSchema,
	TableMetadata,
	ColumnMetadata
} from "./types";

export class LienSchema implements IFormTableSchema<Lien> {
	tableMetadata: TableMetadata<Partial<Lien>> = {
		addRowButtonIsDisabled: (form, row) => {
			const properties = (form?.["Calculator"]?.["PROPERTIES"] ||
				[]) as Property[];
			return properties.length === 0;
		},
		isDeletableRow(rowData, cells) {
			return Boolean(rowData.addedManually);
		},
		rowFilterer(allRows: Lien[], formValues?: Record<string, any> | undefined) {
			if (formValues) {
				const refinancedProperties = (
					formValues["Calculator"]["PROPERTIES"] as Property[]
				)
					.filter(x => x.refinance === true)
					.map(x => x.uniquePropertyId);
				return allRows.filter(x =>
					refinancedProperties.includes(x.uniquePropertyId)
				);
			}
			return allRows;
		}
	};

	columnMetadata: Partial<Record<keyof Lien, ColumnMetadata<Lien>>> = {
		creditorOrgNo: {
			fieldType: FieldType.Text,
			isRequired: true,
			isEditableFunctions: {
				canEditPropertyId: (row, columnCells) => {
					return Boolean(row.values.addedManually);
				}
			}
		},
		creditorName: {
			fieldType: FieldType.Text,
			isRequired: true,
			isEditableFunctions: {
				canEditPropertyId: (row, columnCells) => {
					return Boolean(row.values.addedManually);
				}
			}
		},
		registrationDate: {
			fieldType: FieldType.Date,
			isRequired: true,
			isEditableFunctions: {
				canEditPropertyId: (row, columnCells) => {
					return Boolean(row.values.addedManually);
				}
			}
		},
		priority: {
			fieldType: FieldType.Number
		},
		yieldPriority: {
			fieldType: FieldType.Checkbox
		},
		documentId: {
			fieldType: FieldType.Text,
			isRequired: true,
			isEditableFunctions: {
				canEditPropertyId: (row, columnCells) => {
					return Boolean(row.values.addedManually);
				}
			}
		},
		value: {
			fieldType: FieldType.Currency,
			isRequired: true
		},
		writtenDownValue: {
			fieldType: FieldType.Currency
		},
		uniquePropertyId: {
			fieldType: FieldType.Select,
			isRequired: true,
			isMultiline: true,
			isEditableFunctions: {
				canEditPropertyId: (row, columnCells) => {
					return Boolean(row.values.addedManually);
				}
			}
		},
		addedManually: {
			// Need column-metadata for this field even though this field is not rendered in the FormTable.
			// We need this defaultvalue to be set for every new entity
			fieldType: FieldType.Hidden,
			defaultValue: true
		},
		reuseLien: {
			fieldType: FieldType.Checkbox,
			isEditableFunctions: {
				onlyOneReusableLien: (row, columnCells, tableData) => {
					const anyOtherLienIsReused = tableData.some(
						c => c.reuseLien && c.documentId !== row.values.documentId
					);
					return anyOtherLienIsReused === false;
				}
			}
		}
	};
}
